<div *ngIf="totalPrice > 0" class="total-price-container">
  <div class="total-price-display-left-space"></div>
  <div class="total-price-display">
    <div class="d-flex justify-content-between">
      <span>Totaal excl. BTW</span>
      <span>€ {{ totalPrice | asFormatDecimal: true:2 }}</span>
    </div>
    <div class="d-flex justify-content-between">
      <span>Btw 21%</span>
      <span>€ {{ totalPrice | multiply: 0.21 | asFormatDecimal: true:2 }}</span>
    </div>

    <div class="d-flex justify-content-between">
      <span class="strong">
        Totaal incl. BTW
        <mat-icon
          class="price-warning-icon"
          *ngIf="atLeastOneNonStandardPrice"
          matTooltip="Enkel de standaardborden zijn meegerekend in de getoonde prijs"
          >report_problem</mat-icon
        >
      </span>
      <span class="strong">
        € {{ totalPrice | multiply: 1.21 | asFormatDecimal: true:2 }}
      </span>
    </div>
  </div>
</div>
